import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container storeName" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "flex customer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "container empty"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Retrieving Data "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-spin pi-spinner",
    style: {"font-size":"3rem"}
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "container"
}
const _hoisted_10 = { class: "wo-details" }
const _hoisted_11 = { class: "customer" }
const _hoisted_12 = { class: "mr-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Invoice Count:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "PROFIT")
], -1)
const _hoisted_15 = { class: "flex flex-wrap flex-row items" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Profit")
], -1)
const _hoisted_18 = { class: "flex flex-wrap flex-row info" }
const _hoisted_19 = { class: "values" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Gross Profit $ ")
const _hoisted_22 = { class: "pi pi-info-circle" }
const _hoisted_23 = { class: "value cond" }
const _hoisted_24 = { class: "values" }
const _hoisted_25 = { class: "content" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Gross Profit % ")
const _hoisted_27 = { class: "pi pi-info-circle" }
const _hoisted_28 = { class: "value cond" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "SALES & REVENUE")
  ])
], -1)
const _hoisted_30 = { class: "flex flex-wrap flex-row items" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Sales")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Sales", -1)
const _hoisted_34 = { class: "flex flex-1 justify-content-center chart doughnut" }
const _hoisted_35 = { class: "center value cond" }
const _hoisted_36 = { class: "flex flex-wrap flex-row info values-tab" }
const _hoisted_37 = { class: "values" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Average Invoice ")
const _hoisted_40 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_41 = { class: "value cond" }
const _hoisted_42 = { class: "values" }
const _hoisted_43 = { class: "content" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_45 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_46 = { class: "value cond" }
const _hoisted_47 = { class: "values" }
const _hoisted_48 = { class: "content" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Tire Sales ")
const _hoisted_50 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_51 = { class: "value cond" }
const _hoisted_52 = { class: "values" }
const _hoisted_53 = { class: "content" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Parts Sales ")
const _hoisted_55 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_56 = { class: "value cond" }
const _hoisted_57 = { class: "values" }
const _hoisted_58 = { class: "content" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Labor Sales ")
const _hoisted_60 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_61 = { class: "value cond" }
const _hoisted_62 = { class: "values" }
const _hoisted_63 = { class: "content" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Sublet Sales ")
const _hoisted_65 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_66 = { class: "value cond" }
const _hoisted_67 = { class: "values" }
const _hoisted_68 = { class: "content" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Tire Count ")
const _hoisted_70 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_71 = { class: "value cond" }
const _hoisted_72 = { class: "item" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Revenue")
], -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Revenue Total", -1)
const _hoisted_75 = { class: "flex flex-1 justify-content-center chart doughnut" }
const _hoisted_76 = { class: "center value cond" }
const _hoisted_77 = { class: "flex flex-wrap flex-row info" }
const _hoisted_78 = { class: "flex flex-wrap flex-row info values-tab" }
const _hoisted_79 = { class: "values" }
const _hoisted_80 = { class: "content" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Revenue Total ")
const _hoisted_82 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_83 = { class: "value cond" }
const _hoisted_84 = { class: "values" }
const _hoisted_85 = { class: "content" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Taxes ")
const _hoisted_87 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_88 = { class: "value cond" }
const _hoisted_89 = { class: "values" }
const _hoisted_90 = { class: "content" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_92 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_93 = { class: "value cond" }
const _hoisted_94 = { class: "values" }
const _hoisted_95 = { class: "content" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Other Charges ")
const _hoisted_97 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_98 = { class: "value cond" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "OPPORTUNITY")
  ])
], -1)
const _hoisted_100 = { class: "flex flex-wrap flex-row items" }
const _hoisted_101 = { class: "item" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Opportunity")
], -1)
const _hoisted_103 = { class: "flex flex-wrap flex-row items" }
const _hoisted_104 = { class: "item" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Total Opportunity", -1)
const _hoisted_106 = { class: "flex flex-1 justify-content-center chart doughnut" }
const _hoisted_107 = { class: "center value cond" }
const _hoisted_108 = { class: "item" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Hours Presented", -1)
const _hoisted_110 = { class: "flex flex-1 justify-content-center chart doughnut" }
const _hoisted_111 = { class: "center value cond" }
const _hoisted_112 = { class: "flex flex-wrap flex-row info values-tab" }
const _hoisted_113 = {
  class: "values",
  style: {"order":"1"}
}
const _hoisted_114 = { class: "content" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Total Opportunity ")
const _hoisted_116 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_117 = { class: "value cond" }
const _hoisted_118 = {
  class: "values",
  style: {"order":"3"}
}
const _hoisted_119 = { class: "content" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode("Average Opportunity ")
const _hoisted_121 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_122 = { class: "value cond" }
const _hoisted_123 = {
  class: "values",
  style: {"order":"5"}
}
const _hoisted_124 = { class: "content" }
const _hoisted_125 = /*#__PURE__*/_createTextVNode("Closing Ratio ")
const _hoisted_126 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_127 = { class: "value cond" }
const _hoisted_128 = {
  class: "values",
  style: {"order":"2"}
}
const _hoisted_129 = { class: "content" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode("Deferred Total ")
const _hoisted_131 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_132 = { class: "value cond" }
const _hoisted_133 = {
  class: "values",
  style: {"order":"4"}
}
const _hoisted_134 = { class: "content" }
const _hoisted_135 = /*#__PURE__*/_createTextVNode("Deferred Average ")
const _hoisted_136 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_137 = { class: "value cond" }
const _hoisted_138 = {
  class: "values",
  style: {"order":"6"}
}
const _hoisted_139 = { class: "content" }
const _hoisted_140 = /*#__PURE__*/_createTextVNode("Deferred Hours ")
const _hoisted_141 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_142 = { class: "value cond" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "LABOR")
], -1)
const _hoisted_144 = { class: "flex flex-wrap flex-row items" }
const _hoisted_145 = { class: "item" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Labor")
], -1)
const _hoisted_147 = { class: "flex flex-wrap flex-row info" }
const _hoisted_148 = { class: "values" }
const _hoisted_149 = { class: "content" }
const _hoisted_150 = /*#__PURE__*/_createTextVNode("Labor Sales ")
const _hoisted_151 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_152 = { class: "value cond" }
const _hoisted_153 = { class: "values" }
const _hoisted_154 = { class: "content" }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("Average Hours Billed ")
const _hoisted_156 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_157 = { class: "value cond" }
const _hoisted_158 = { class: "values" }
const _hoisted_159 = { class: "content" }
const _hoisted_160 = /*#__PURE__*/_createTextVNode("Effective Labor Rate ")
const _hoisted_161 = {
  key: 0,
  class: "pi pi-info-circle"
}
const _hoisted_162 = { class: "value cond" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("h3", null, "Sales & Revenue Settings", -1)
const _hoisted_164 = { class: "field" }
const _hoisted_165 = { class: "flex justify-content-center" }
const _hoisted_166 = { class: "flex-auto gap-2" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", {
  for: "viewDefault",
  style: {"display":"block","height":"2rem"}
}, "Default View:", -1)
const _hoisted_168 = { class: "confirm p-sidebar-close" }

import Chart from 'primevue/chart';
import { ref, onMounted } from "vue";
import Sidebar from 'primevue/sidebar';
import SelectButton from 'primevue/selectbutton';
import { useAuth0 } from "@auth0/auth0-vue";
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import moment from 'moment';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  name: 'Reporting',
  setup(__props) {

const auth0 = useAuth0();
const loading = ref(true);
const searchLoad = ref(false);
const summaryreport = ref();
const invoiceTotal = ref([]);
const grossProfit = ref([]);
const grossProfitPercentage = ref([]);

const partsSales = ref([]);
const tireSales = ref([]);
const laborSales = ref([]);
const subletSales = ref([]);
const netTotal = ref([]);
const averageInvoice = ref([]);
const tireCount = ref([]);

const revenueTotal = ref([]);
const taxes = ref([]);
const otherCharges = ref([]);

const totalOpportunity = ref([]);
const averageOpportunity = ref([]);
const closingRatio = ref([]);
const deferredTotal = ref([]);
const deferredAverage = ref([]);
const deferredHours = ref([]);
const hoursSold = ref([]);
const hoursPresented = ref([]);

const averageHoursBilled = ref([]);
const effectiveLaborRate = ref([]);

const settings = ref(false);
const salesPieData = ref();
const pieOptions = ref();
const revenuePieData = ref();
const revenueOptions = ref();
const totalOppData = ref();
const totalOppOptions = ref();
const hoursData = ref();
const hoursOptions = ref();
// - Presented [value|hour] % in chart
// - Billed [value|hour] % in chart
// - Sold [value|hour] (same as ‘Billed’?) % in chart
const dates = ref([]);
const defaultView = ref('Chart');
const defaultOptions = ref(['Chart', 'Values']);

const selectedPeriod = ref();
const periods = ref([
    { name: 'Today', code: 'today' },
    { name: 'This Week', code: 'tw' },
    { name: 'This Month', code: 'tm' },
    { name: 'This Quarter', code: 'tq' },
    { name: 'This Year', code: 'ty' },
    { name: 'Yesterday', code: 'yesterday' },
    { name: 'Last Week', code: 'lw' },
    { name: 'Last Month', code: 'lm' },
    { name: 'Last Quarter', code: 'lq' },
    { name: 'Last Year', code: 'ly' },
]);

const storename = ref();
const initialLoad = ref(true);
const store = useStore();

onMounted(async () => {
    storename.value = store.state.storename;
    await searchSummaryReport();
    pieOptions.value = setPieOptions(); // set legends at the bottom of the chart
    revenueOptions.value = setRevenueOptions(); // set legends at the bottom of the chart
    totalOppOptions.value = setTotalOppOptions();
    hoursOptions.value = setHoursOptions();
    initialLoad.value = false;
});

const setSalesPieChart = () => {
    const documentStyle = getComputedStyle(document.body);
    return {
        labels: [' Parts Sales $', ' Tire Sales $', ' Labor Sales $', ' Sublet Sales $'],
        datasets: [
            {
                data: [partsSales.value.CurrentAmount, tireSales.value.CurrentAmount, laborSales.value.CurrentAmount, subletSales.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};
  
const setPieOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const setRevenuePieChart = () => {
    const documentStyle = getComputedStyle(document.body);
    return {
        labels: [' Revenue Total $', ' Taxes $', ' Other Charges $'],
        datasets: [
            {
                data: [revenueTotal.value.CurrentAmount, taxes.value.CurrentAmount, otherCharges.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};
  
const setRevenueOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const setTotalOppPieChart = () => {
    const documentStyle = getComputedStyle(document.body);

    return {
        labels: [' Revenue Total $', ' Deferred Total $'],
        datasets: [
            {
                data: [revenueTotal.value.CurrentAmount, deferredTotal.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};

const setTotalOppOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const setHoursPieChart = () => {
    const documentStyle = getComputedStyle(document.body);

    return {
        labels: [' Hours Sold', ' Deferred Hours'],
        datasets: [
            {
                data: [hoursSold.value.CurrentAmount, deferredHours.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};

const setHoursOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            title: {
                text: 'Total Opportunity',
            },
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const searchSummaryReport = async () => {
    if (initialLoad.value === true) {
      const today = moment();
      const startDate = today.clone().startOf('month').format('MM/DD/YYYY');
      const endDate = today.clone().endOf('month').format('MM/DD/YYYY');
      const calendarElement = document.getElementById('calendar-input');
      const inputElement = calendarElement?.querySelector('input');
      dates.value[0] = startDate;
      dates.value[1] = endDate;
      selectedPeriod.value = periods.value[2]; //This Month
      if (inputElement) {
        inputElement.value = `${startDate} - ${endDate}`;
      }
    }

    if (dates.value[0] && dates.value[1]) {
        const startDate = moment(dates.value[0]).format('MM/DD/YYYY');
        const endDate = moment(dates.value[1]).format('MM/DD/YYYY');
        loading.value = true;
        searchLoad.value = true;
        await getSummaryReport(startDate, endDate);
        loading.value = false;
        searchLoad.value = false;
    }
}

const getSummaryReport = async (startDate, endDate) => {
    const storeid = store.state.storeid;
    const WOurl = `${process.env.VUE_APP_NODEJS_BASE_URL}reporting/salessummaryreport/${storeid}?startDate=${startDate}&endDate=${endDate}`;
    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(WOurl, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'Accept-Encoding': 'gzip'
            }
        });

        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        summaryreport.value = data.message;
        setCurrentCount();
        setProfitData();
        setSalesandRevenueData();
        setTotalOppandHoursData();
        setLaborData();
        loading.value = false;
    } catch (e) {
        openErrorModal(e.message);
    }
}

const setCurrentCount = () => {
    invoiceTotal.value = summaryreport.value.find(item => item.Name === "InvoiceTotal");
}

const setProfitData = () => {
    grossProfit.value = summaryreport.value.find(item => item.Name === "GrossProfit");
    grossProfitPercentage.value = summaryreport.value.find(item => item.Name === "GrossProfitPercentage");
    grossProfitPercentage.value.CurrentAmount *= 100;
}

const setSalesandRevenueData = () => {
    // Sales
    partsSales.value = summaryreport.value.find(item => item.Name === "PartsSales");
    tireSales.value = summaryreport.value.find(item => item.Name === "TireSales");
    laborSales.value = summaryreport.value.find(item => item.Name === "LaborSales");
    subletSales.value = summaryreport.value.find(item => item.Name === "SubletSales");
    netTotal.value = summaryreport.value.find(item => item.Name === "NetTotal");
    averageInvoice.value = summaryreport.value.find(item => item.Name === "AverageInvoice");
    tireCount.value = summaryreport.value.find(item => item.Name === "TireCount");

    // Revenue
    revenueTotal.value = summaryreport.value.find(item => item.Name === "RevenueTotal");
    taxes.value = summaryreport.value.find(item => item.Name === "Taxes");
    otherCharges.value = summaryreport.value.find(item => item.Name === "OtherCharges");

    salesPieData.value = setSalesPieChart();
    revenuePieData.value = setRevenuePieChart();
}

const setTotalOppandHoursData = () => {
    totalOpportunity.value = summaryreport.value.find(item => item.Name === "TotalOpportunity");
    averageOpportunity.value = summaryreport.value.find(item => item.Name === "AverageOpportunity");
    closingRatio.value = summaryreport.value.find(item => item.Name === "ClosingRatio");
    closingRatio.value.CurrentAmount *= 100;
    deferredTotal.value = summaryreport.value.find(item => item.Name === "DeferredTotal");
    deferredAverage.value = summaryreport.value.find(item => item.Name === "DeferredAverage");
    deferredHours.value = summaryreport.value.find(item => item.Name === "DeferredHours");
    hoursSold.value = summaryreport.value.find(item => item.Name === "HoursSold");
    hoursPresented.value = summaryreport.value.find(item => item.Name === "HoursPresented");
    
    totalOppData.value = setTotalOppPieChart();
    hoursData.value = setHoursPieChart();
}

const setLaborData = () => {
    averageHoursBilled.value = summaryreport.value.find(item => item.Name === "AverageHoursBilled");
    effectiveLaborRate.value = summaryreport.value.find(item => item.Name === "EffectiveLaborRate");
}

const setDenomination = (number) => {
    return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 5 });
}

const setStatusClass = (status) => {
    return {
        'pi': true,
        'pi-arrow-circle-up': status === 'Up',
        'pi-arrow-circle-down': status === 'Down',
        'pi-minus-circle': status === 'Equal'
    };
}

const setPeriodDates = async () => {
    const today = moment();
    let startDate, endDate;

    switch (selectedPeriod.value.code) {
        case 'today':
            startDate = endDate = today;
            break;
        case 'yesterday':
            startDate = endDate = today.subtract(1, 'day');
            break;
        case 'tw':
            startDate = today.clone().startOf('week');
            endDate = today.clone().endOf('week');
            break;
        case 'tm':
            startDate = today.clone().startOf('month');
            endDate = today.clone().endOf('month');
            break;
        case 'tq':
            startDate = today.clone().startOf('quarter');
            endDate = today.clone().endOf('quarter');
            break;
        case 'ty':
            startDate = today.clone().startOf('year');
            endDate = today.clone().endOf('year');
            break;
        case 'lw':
            startDate = today.clone().subtract(1, 'week').startOf('week');
            endDate = today.clone().subtract(1, 'week').endOf('week');
            break;
        case 'lm':
            startDate = today.clone().subtract(1, 'month').startOf('month');
            endDate = today.clone().subtract(1, 'month').endOf('month');
            break;
        case 'lq':
            startDate = today.clone().subtract(1, 'quarter').startOf('quarter');
            endDate = today.clone().subtract(1, 'quarter').endOf('quarter');
            break;
        case 'ly':
            startDate = today.clone().subtract(1, 'year').startOf('year');
            endDate = today.clone().subtract(1, 'year').endOf('year');
            break;
    }

    dates.value = [startDate.toDate(), endDate.toDate()];

    await searchSummaryReport();
}

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(storename.value), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          modelValue: selectedPeriod.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPeriod).value = $event)),
          options: periods.value,
          optionLabel: "name",
          placeholder: "Select Period",
          onChange: setPeriodDates
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_Calendar, {
          modelValue: dates.value,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((dates).value = $event)),
            searchSummaryReport
          ],
          selectionMode: "range",
          placeholder: "Select Date Range",
          id: "calendar-input"
        }, null, 8, ["modelValue"]),
        _hoisted_5,
        _createVNode(_component_Button, {
          type: "button",
          label: "Set",
          loading: searchLoad.value,
          onClick: searchSummaryReport,
          class: "p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2",
          style: {"display":"none"}
        }, null, 8, ["loading"])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(invoiceTotal.value.CurrentAmount), 1)
              ])
            ])
          ]),
          _createVNode(_component_Panel, {
            id: "profit",
            toggleable: "",
            style: {"margin-bottom":"1rem"}
          }, {
            header: _withCtx(() => [
              _hoisted_14
            ]),
            icons: _withCtx(() => [
              _createVNode(_component_Menu, {
                ref: "menu",
                id: "config_menu",
                model: _ctx.items,
                popup: ""
              }, null, 8, ["model"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("h4", null, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("span", _hoisted_22, null, 512), [
                            [_directive_tooltip, { value: 'Gross Profit (GP$)', autoHide: false }]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_23, [
                          _createTextVNode(_toDisplayString(setDenomination(grossProfit.value.CurrentAmount)) + " ", 1),
                          _withDirectives(_createElementVNode("span", {
                            class: _normalizeClass(setStatusClass(grossProfit.value.Status)),
                            style: {"font-size":"1.75rem"}
                          }, null, 2), [
                            [_directive_tooltip, { value: grossProfit.value.Difference, hideDelay: 10000 }]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h4", null, [
                          _hoisted_26,
                          _withDirectives(_createElementVNode("span", _hoisted_27, null, 512), [
                            [_directive_tooltip, { value: 'Gross Profit % (GP%)', autoHide: false }]
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_28, [
                          _createTextVNode(_toDisplayString(setDenomination(grossProfitPercentage.value.CurrentAmount)) + " % ", 1),
                          _withDirectives(_createElementVNode("span", {
                            class: _normalizeClass(setStatusClass(grossProfitPercentage.value.Status)),
                            style: {"font-size":"1.75rem"}
                          }, null, 2), [
                            [_directive_tooltip, { value: grossProfitPercentage.value.Difference, autoHide: false }]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            id: "salesandrevenue",
            toggleable: "",
            style: {"margin-bottom":"1rem"}
          }, {
            header: _withCtx(() => [
              _hoisted_29
            ]),
            icons: _withCtx(() => [
              _createVNode(_component_Menu, {
                ref: "menu",
                id: "config_menu",
                model: _ctx.items,
                popup: ""
              }, null, 8, ["model"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_component_TabView, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_TabPanel, { header: "Chart" }, {
                        default: _withCtx(() => [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_unref(Chart), {
                              type: "doughnut",
                              data: salesPieData.value,
                              options: pieOptions.value
                            }, null, 8, ["data", "options"]),
                            _createElementVNode("p", _hoisted_35, "$" + _toDisplayString(setDenomination(tireSales.value.CurrentAmount + partsSales.value.CurrentAmount + laborSales.value.CurrentAmount + subletSales.value.CurrentAmount)), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, { header: "Values" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("h4", null, [
                                  _hoisted_39,
                                  (averageInvoice.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_40, null, 512)), [
                                        [_directive_tooltip, { value: averageInvoice.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_41, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(averageInvoice.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(averageInvoice.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: averageInvoice.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("h4", null, [
                                  _hoisted_44,
                                  (netTotal.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_45, null, 512)), [
                                        [_directive_tooltip, { value: netTotal.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_46, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(netTotal.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(netTotal.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: netTotal.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("h4", null, [
                                  _hoisted_49,
                                  (tireSales.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_50, null, 512)), [
                                        [_directive_tooltip, { value: tireSales.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_51, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(tireSales.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(tireSales.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: tireSales.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("h4", null, [
                                  _hoisted_54,
                                  (partsSales.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_55, null, 512)), [
                                        [_directive_tooltip, { value: partsSales.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_56, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(partsSales.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(partsSales.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: partsSales.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("h4", null, [
                                  _hoisted_59,
                                  (laborSales.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_60, null, 512)), [
                                        [_directive_tooltip, { value: laborSales.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_61, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(laborSales.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(laborSales.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: laborSales.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("h4", null, [
                                  _hoisted_64,
                                  (subletSales.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_65, null, 512)), [
                                        [_directive_tooltip, { value: subletSales.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_66, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(subletSales.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(subletSales.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: subletSales.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("h4", null, [
                                  _hoisted_69,
                                  (tireCount.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_70, null, 512)), [
                                        [_directive_tooltip, { value: tireCount.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_71, [
                                  _createTextVNode(_toDisplayString(tireCount.value.CurrentAmount) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(tireCount.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: tireCount.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createVNode(_component_TabView, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_TabPanel, { header: "Chart" }, {
                        default: _withCtx(() => [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_unref(Chart), {
                              type: "doughnut",
                              data: revenuePieData.value,
                              options: revenueOptions.value
                            }, null, 8, ["data", "options"]),
                            _createElementVNode("p", _hoisted_76, "$" + _toDisplayString(setDenomination(revenueTotal.value.CurrentAmount + taxes.value.CurrentAmount + otherCharges.value.CurrentAmount)), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, { header: "Values" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("div", _hoisted_79, [
                                _createElementVNode("div", _hoisted_80, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_81,
                                    (revenueTotal.value.Explanation)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_82, null, 512)), [
                                          [_directive_tooltip, { value: revenueTotal.value.Explanation, autoHide: false }]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("p", _hoisted_83, [
                                    _createTextVNode("$" + _toDisplayString(setDenomination(revenueTotal.value.CurrentAmount)) + " ", 1),
                                    _withDirectives(_createElementVNode("span", {
                                      class: _normalizeClass(setStatusClass(revenueTotal.value.Status)),
                                      style: {"font-size":"1.75rem"}
                                    }, null, 2), [
                                      [_directive_tooltip, { value: revenueTotal.value.Difference, autoHide: false }]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("div", _hoisted_85, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_86,
                                    (taxes.value.Explanation)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_87, null, 512)), [
                                          [_directive_tooltip, { value: taxes.value.Explanation, autoHide: false }]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("p", _hoisted_88, [
                                    _createTextVNode("$" + _toDisplayString(setDenomination(taxes.value.CurrentAmount)) + " ", 1),
                                    _withDirectives(_createElementVNode("span", {
                                      class: _normalizeClass(setStatusClass(taxes.value.Status)),
                                      style: {"font-size":"1.75rem"}
                                    }, null, 2), [
                                      [_directive_tooltip, { value: taxes.value.Difference, autoHide: false }]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_91,
                                    (netTotal.value.Explanation)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_92, null, 512)), [
                                          [_directive_tooltip, { value: netTotal.value.Explanation, autoHide: false }]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("p", _hoisted_93, [
                                    _createTextVNode("$" + _toDisplayString(setDenomination(netTotal.value.CurrentAmount)) + " ", 1),
                                    _withDirectives(_createElementVNode("span", {
                                      class: _normalizeClass(setStatusClass(netTotal.value.Status)),
                                      style: {"font-size":"1.75rem"}
                                    }, null, 2), [
                                      [_directive_tooltip, { value: netTotal.value.Difference, autoHide: false }]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("h4", null, [
                                    _hoisted_96,
                                    (otherCharges.value.Explanation)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_97, null, 512)), [
                                          [_directive_tooltip, { value: otherCharges.value.Explanation, autoHide: false }]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("p", _hoisted_98, [
                                    _createTextVNode("$" + _toDisplayString(setDenomination(otherCharges.value.CurrentAmount)) + " ", 1),
                                    _withDirectives(_createElementVNode("span", {
                                      class: _normalizeClass(setStatusClass(otherCharges.value.Status)),
                                      style: {"font-size":"1.75rem"}
                                    }, null, 2), [
                                      [_directive_tooltip, { value: otherCharges.value.Difference, autoHide: false }]
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            id: "opportunity",
            toggleable: "",
            style: {"margin-bottom":"1rem"}
          }, {
            header: _withCtx(() => [
              _hoisted_99
            ]),
            icons: _withCtx(() => [
              _createVNode(_component_Menu, {
                ref: "menu",
                id: "config_menu",
                model: _ctx.items,
                popup: ""
              }, null, 8, ["model"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createVNode(_component_TabView, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_TabPanel, { header: "Charts" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_103, [
                            _createElementVNode("div", _hoisted_104, [
                              _hoisted_105,
                              _createElementVNode("div", _hoisted_106, [
                                _createVNode(_unref(Chart), {
                                  type: "doughnut",
                                  data: totalOppData.value,
                                  options: totalOppOptions.value,
                                  legend: _ctx.bottom
                                }, null, 8, ["data", "options", "legend"]),
                                _createElementVNode("p", _hoisted_107, "$" + _toDisplayString(setDenomination(revenueTotal.value.CurrentAmount + deferredTotal.value.CurrentAmount)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_108, [
                              _hoisted_109,
                              _createElementVNode("div", _hoisted_110, [
                                _createVNode(_unref(Chart), {
                                  type: "doughnut",
                                  data: hoursData.value,
                                  options: hoursOptions.value
                                }, null, 8, ["data", "options"]),
                                _createElementVNode("p", _hoisted_111, _toDisplayString(hoursPresented.value.CurrentAmount), 1)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TabPanel, { header: "Values" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("h4", null, [
                                  _hoisted_115,
                                  (totalOpportunity.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_116, null, 512)), [
                                        [_directive_tooltip, { value: totalOpportunity.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_117, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(totalOpportunity.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(totalOpportunity.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: totalOpportunity.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("div", _hoisted_119, [
                                _createElementVNode("h4", null, [
                                  _hoisted_120,
                                  (averageOpportunity.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_121, null, 512)), [
                                        [_directive_tooltip, { value: averageOpportunity.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_122, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(averageOpportunity.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(averageOpportunity.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: averageOpportunity.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_123, [
                              _createElementVNode("div", _hoisted_124, [
                                _createElementVNode("h4", null, [
                                  _hoisted_125,
                                  (closingRatio.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_126, null, 512)), [
                                        [_directive_tooltip, { value: closingRatio.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_127, [
                                  _createTextVNode(_toDisplayString(setDenomination(closingRatio.value.CurrentAmount)) + " % ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(closingRatio.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: closingRatio.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("h4", null, [
                                  _hoisted_130,
                                  (deferredTotal.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_131, null, 512)), [
                                        [_directive_tooltip, { value: deferredTotal.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_132, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(deferredTotal.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(deferredTotal.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: deferredTotal.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("div", _hoisted_134, [
                                _createElementVNode("h4", null, [
                                  _hoisted_135,
                                  (deferredAverage.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_136, null, 512)), [
                                        [_directive_tooltip, { value: deferredAverage.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_137, [
                                  _createTextVNode("$" + _toDisplayString(setDenomination(deferredAverage.value.CurrentAmount)) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(deferredAverage.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: deferredAverage.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("h4", null, [
                                  _hoisted_140,
                                  (deferredHours.value.Explanation)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_141, null, 512)), [
                                        [_directive_tooltip, { value: deferredHours.value.Explanation, autoHide: false }]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_142, [
                                  _createTextVNode(_toDisplayString(deferredHours.value.CurrentAmount) + " ", 1),
                                  _withDirectives(_createElementVNode("span", {
                                    class: _normalizeClass(setStatusClass(deferredHours.value.Status)),
                                    style: {"font-size":"1.75rem"}
                                  }, null, 2), [
                                    [_directive_tooltip, { value: deferredHours.value.Difference, autoHide: false }]
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Panel, {
            id: "labour",
            toggleable: ""
          }, {
            header: _withCtx(() => [
              _hoisted_143
            ]),
            icons: _withCtx(() => [
              _createVNode(_component_Menu, {
                ref: "menu",
                id: "config_menu",
                model: _ctx.items,
                popup: ""
              }, null, 8, ["model"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("div", _hoisted_145, [
                  _hoisted_146,
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _createElementVNode("div", _hoisted_149, [
                        _createElementVNode("h4", null, [
                          _hoisted_150,
                          (laborSales.value.Explanation)
                            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_151, null, 512)), [
                                [_directive_tooltip, { value: laborSales.value.Explanation, autoHide: false }]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_152, [
                          _createTextVNode(_toDisplayString(setDenomination(laborSales.value.CurrentAmount)) + " ", 1),
                          _withDirectives(_createElementVNode("span", {
                            class: _normalizeClass(setStatusClass(laborSales.value.Status)),
                            style: {"font-size":"1.75rem"}
                          }, null, 2), [
                            [_directive_tooltip, { value: laborSales.value.Difference, autoHide: false }]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("h4", null, [
                          _hoisted_155,
                          (averageHoursBilled.value.Explanation)
                            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_156, null, 512)), [
                                [_directive_tooltip, { value: averageHoursBilled.value.Explanation, autoHide: false }]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_157, [
                          _createTextVNode(_toDisplayString(averageHoursBilled.value.CurrentAmount) + " % ", 1),
                          _withDirectives(_createElementVNode("span", {
                            class: _normalizeClass(setStatusClass(averageHoursBilled.value.Status)),
                            style: {"font-size":"1.75rem"}
                          }, null, 2), [
                            [_directive_tooltip, { value: averageHoursBilled.value.Difference, autoHide: false }]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_158, [
                      _createElementVNode("div", _hoisted_159, [
                        _createElementVNode("h4", null, [
                          _hoisted_160,
                          (effectiveLaborRate.value.Explanation)
                            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_161, null, 512)), [
                                [_directive_tooltip, { value: effectiveLaborRate.value.Explanation, autoHide: false }]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_162, [
                          _createTextVNode("$" + _toDisplayString(setDenomination(effectiveLaborRate.value.CurrentAmount)) + " ", 1),
                          _withDirectives(_createElementVNode("span", {
                            class: _normalizeClass(setStatusClass(effectiveLaborRate.value.Status)),
                            style: {"font-size":"1.75rem"}
                          }, null, 2), [
                            [_directive_tooltip, { value: effectiveLaborRate.value.Difference, autoHide: false }]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Sidebar), {
            visible: settings.value,
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((settings).value = $event)),
            header: "Sidebar",
            position: "right"
          }, {
            default: _withCtx(() => [
              _hoisted_163,
              _createElementVNode("div", _hoisted_164, [
                _createElementVNode("div", _hoisted_165, [
                  _createElementVNode("div", _hoisted_166, [
                    _hoisted_167,
                    _createVNode(_unref(SelectButton), {
                      modelValue: defaultView.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((defaultView).value = $event)),
                      options: defaultOptions.value,
                      id: "viewDefault",
                      "aria-labelledby": "basic"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_168, [
                _createVNode(_component_Button, {
                  label: "Save",
                  class: "p-button p-component p-button-rounded btn-secondary"
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})